window.addEventListener("load", () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

  const video = document.getElementById("hero-video")
  if (!video) return

  const sources = video.querySelectorAll("source")

  sources.forEach(source => {
    source.src = source.dataset.src
  })

  video.load()

  const playPromise = video.play()

  if (playPromise) {
    playPromise.then(() => {
      video.classList.add("is-ready")
    }).catch(() => {})
  }
})